/**
 * Locks the cart checkout CTA until the terms of service checkbox is ticked.
 *
 * The cart drawer replaces its own innerHTML on every cart update (see
 * cart-drawer.bundle.js renderContents), so the checkbox element is thrown away
 * and rebuilt regularly. The agreement is therefore held here and re-applied
 * whenever the markup changes. It is deliberately not persisted to storage: a
 * box that arrives pre-ticked on a fresh page load is not a consent record.
 */
(function () {
  'use strict';

  var GATE = '[data-terms-agreement-gate]';
  var INPUT = '[data-terms-agreement-input]';
  var ERROR = '[data-terms-agreement-error]';

  var agreed = false;
  var syncQueued = false;

  function isGated() {
    return document.querySelector(INPUT) !== null;
  }

  function setError(visible) {
    document.querySelectorAll(ERROR).forEach(function (element) {
      element.hidden = !visible;
    });
  }

  function sync() {
    syncQueued = false;

    var locked = isGated() && !agreed;

    document.querySelectorAll(INPUT).forEach(function (input) {
      if (input.checked !== agreed) input.checked = agreed;
    });

    document.querySelectorAll(GATE).forEach(function (cta) {
      cta.setAttribute('aria-disabled', locked ? 'true' : 'false');
      if (locked) {
        cta.setAttribute('tabindex', '-1');
      } else {
        cta.removeAttribute('tabindex');
      }
    });

    if (!locked) setError(false);
  }

  function queueSync() {
    if (syncQueued) return;
    syncQueued = true;
    window.requestAnimationFrame(sync);
  }

  document.addEventListener('change', function (event) {
    var input = event.target.closest && event.target.closest(INPUT);
    if (!input) return;

    agreed = input.checked;
    sync();
  });

  // Capture phase, so the navigation is stopped before any theme handler runs.
  document.addEventListener(
    'click',
    function (event) {
      var cta = event.target.closest && event.target.closest(GATE);
      if (!cta || !isGated() || agreed) return;

      event.preventDefault();
      event.stopPropagation();
      setError(true);

      var input = document.querySelector(INPUT);
      if (input) input.focus();
    },
    true
  );

  function observe() {
    var roots = [
      document.getElementById('cart-drawer'),
      document.getElementById('MainContent')
    ].filter(Boolean);

    if (!roots.length) roots = [document.body];

    var observer = new MutationObserver(queueSync);
    roots.forEach(function (root) {
      observer.observe(root, { childList: true, subtree: true });
    });
  }

  function init() {
    document.documentElement.classList.add('cart-terms-ready');
    observe();
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
